export default __webpack_public_path__ + "static/brush-stroke-pink-red-6b8d31b32e34f73aedc7d3c41a5d72ee.svg";